import PropTypes from 'prop-types'
/* eslint-disable
    import/default,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import { Link } from 'react-router'

import Avatar from 'shared-web/src/components/Avatar'
import Input from 'shared-web/src/components/Input'
import EditableInfoCard from '../EditableInfoCard'
import FormHelpers from 'utils/FormHelpers'
import Location from '../Location'
import MakeInputChangeHandler from 'mixins/MakeInputChangeHandler'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import './style.styl'

const EndUserIdentity = React.createClass({
  mixins: [MakeInputChangeHandler],

  propTypes: {
    endUser: PropTypes.object,
    isEditMode: PropTypes.bool
  },

  getDataFromProps(props) { if (props == null) { ({ props } = this) } return {
    name: getDisplayName(props.endUser),
    location: props.endUser.attributes.display_location
  } },

  getInitialState() { return {
    data: this.getDataFromProps(),
    isEditMode: this.props.isEditMode,
    disableOnClickOutside: false
  } },

  componentWillReceiveProps(nextProps) {
    return this.setState({
      data: this.getDataFromProps(nextProps)
    })
  },

  createRenderEdit(key, label, autoFocus, isValid) {
    if (isValid == null) { isValid = true }
    return () => {
      return (
        <div>
          <div className="edit-label">
            {label}
          </div>
          <Input
            autoFocus={autoFocus}
            placeholder={label}
            isValid={isValid}
            valueLink={{
              value: this.state.data[key],
              requestChange: this.makeInputChangeHandler(`data.${ key }`)
            }} />
        </div>
      )
    }
  },

  render() {
    return (
      <div className="EndUserIdentity">
        <EditableInfoCard
          isEditMode={this.state.isEditMode}
          canSave={this.hasValidName()}
          hasChanged={this.hasDataChanged()}
          save={this.save}
          reset={() => this.setState(this.getInitialState())}
          beforeDisplay={() => {
            return <Avatar user={this.props.endUser} size="jumbo" />
          }}
          beforeEdit={() => {
            return <Avatar user={this.props.endUser} size="large" />
          }}
          sections={[
            {
              renderEdit: this.createRenderEdit('name', 'Name', true, this.hasValidName()),
              renderDisplay: () => {
                const { name } = this.state.data
                if (!name) { return }
                return (
                  <Link to={`/contacts/details/${ this.props.endUser.id }`} title={name} target="_self">
                    <div className="name">
                      {name}
                    </div>
                  </Link>
                )
              }
            }
          ]} />
      </div>
    )
  },

  hasValidName() {
    return (this.state.data.name == null) || (_.trim(this.state.data.name).length > 0)
  },

  hasDataChanged() {
    const originalData = this.normalizeData(this.getDataFromProps())
    const newData = this.normalizeData(this.state.data)
    return !_.isEqual(newData, originalData)
  },

  normalizeData(data) {
    return _.mapValues(data, function(value) {
      if (value === '') {
        return undefined
      } else {
        return value
      }
    })
  },

  save() {
    if (!this.hasDataChanged()) { return }

    const updateParams = _.pickBy(this.state.data, (v, k) => k && v)
    this.props.actions.EndUserActions.updateEndUser(this.props.endUser.id, {
      name: updateParams.name,
      attributes: {
        display_location: updateParams.location
      }
    })
    return this.props.actions.NotificationActions.pushNotification({
      content: `${ this.props.endUser.name }'s Identity card has been updated!`
    })
  }
})

export default EndUserIdentity



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserIdentity/index.js